import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {httpUpdateAccess, HttpUpdateAccessOptions} from '../http/accesses.http'
import {errorHandler, raise} from '@/utilities/helpers'
import {MUTATION_KEYS} from '@/queryClient'

export const useUpdateAccess = (
    urlParams: HttpUpdateAccessOptions['urlParams'],
    options?: Omit<UseMutationOptions<unknown, AxiosError, HttpUpdateAccessOptions['payload']>, 'mutationFn'>
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.UPDATE_ACCESS, urlParams.accessId],
        mutationFn: payload =>
            httpUpdateAccess({urlParams: {accessId: urlParams.accessId || raise('accessId is required')}, payload}),
        onSuccess: async (data, variables, context) => {
            await options?.onSuccess?.(data, variables, context)
        },
        onError: (error, variables, context) => {
            errorHandler(error)
            options?.onError?.(error, variables, context)
        }
    })
}
